import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import _ from "lodash";
import moment from 'moment';
import numeral from 'numeral';
import { ActiveLoanHeader } from './activeLoanHeader';
import { activeLoanAdd, activeLoansGetByDealAndStatus } from './activeLoan.store';
import { ModuleEmptyButton, LOAN_STATUSES, LOAN_SENIORITY_TYPES, DEAL_METRICS, ModuleBase, mapMetricFromList, GUEST_PERMISSIONS } from "@loanbossinc/component-library";
import { ActiveLoanBodySummary } from "./activeLoanBodySummary";
import { ActiveLoanBodyList } from "./activeLoanBodyList";
import { sortLoansBySeniority, findDistinctLendersByLoans } from "./activeLoan.filters";
import ActiveLoanHedge from "./activeLoanHedges/activeLoanHedge";
import { Collapse } from "@material-ui/core";
import {SimpleInfoModal} from '../../modals/SimpleInfoModal';
import { withLDConsumer } from "launchdarkly-react-client-sdk";

const StyledBody = styled.div`
&& {
    height: 288px;
    width: 648px;
}`;

const MAX_LENDERS_TO_SHOW = 3;

const SIMPLE_INFO_MODAL = 'SIMPLE_INFO_MODAL';

class ActiveLoan extends Component {
    state = {
        openModal: { name: null },
        isSummaryView: true,
        bodySummaryDealMetric: [],
        sortedLoans: [],
        distinctLenders: [],
        confirmationModal:{
            title:"",
            onClose:()=>{},
            onAccept:()=>{},
            onAccept:()=>{},
            content:"",
        }
    }

    componentDidMount() {
        this.props.activeLoansGetByDealAndStatus({ dealId: this.props.match.params.dealId, loanStatusId: LOAN_STATUSES.CLOSED_LOAN });
        this.setNewState();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.findBodySummaryDealMetrics();
            this.setNewState();
        }
    }

    setNewState = () => {
        const { loans } = this.props;
        const sortedLoans = sortLoansBySeniority(loans);
        const distinctLenders = findDistinctLendersByLoans(loans, MAX_LENDERS_TO_SHOW);
        this.setState({ sortedLoans, distinctLenders });
    }

    findBodySummaryDealMetrics = () => {
        if (!this.props.loans || this.props.loans.length === 0) {
            return;
        }

        const loan = this.props.loans[0];

        if (!loan) {
            return;
        }

        const bodySummaryMetrics = [
            { label: 'LOAN AMOUNT', field: "amount", formatter:(value) => numeral(value).format('$0,0')},
            { label: 'PREPAYMENT PENALTY', field: "prepaymentPenalty", supplementalField: "isLockout", formatter:(value) => numeral(value).format('$0,0'), alternativeFormatter:() => "LOCKOUT"},
            { label: 'ALL-IN RATE', field: "allInRateRaw", formatter: (value) => numeral(value).format('0.00%') },
            { label: 'RATE TYPE', field: "rateTypeRef.name", formatter: (value) => value },
            { label: 'MATURITY', field: "maturityDate", formatter: (value) => moment(value).utc().format('MM/DD/YYYY') },
            { label: 'SPREAD', field: "loanSpread", formatter: (value) => numeral(value).format('0.00%') }
        ];

        const bodySummaryDealMetric = [];

        for (const bodySummaryMetric of bodySummaryMetrics) {
            const value = _.get(loan, bodySummaryMetric.field);

            const useAltFormatter = bodySummaryMetric.supplementalField ? _.get(loan, bodySummaryMetric.supplementalField) : undefined;

            const formattedValue = useAltFormatter ? bodySummaryMetric.alternativeFormatter(value) : bodySummaryMetric.formatter(value);

            bodySummaryDealMetric.push({ label: bodySummaryMetric.label, metricValue: formattedValue });
        }

        this.setState({ bodySummaryDealMetric });
    }

    addNewLoan = () => {
        const { history } = this.props;
        const newLoan = {
            loan: {
                dealId: this.props.match.params.dealId
                , loanStatusId: LOAN_STATUSES.CLOSED_LOAN
                , loanSeniorityId: LOAN_SENIORITY_TYPES.SENIOR
            },
            callback: () => history.push(`/loans/${this.props.createdLoan.id}`)
        };
        this.props.activeLoanAdd(newLoan);
    }

    addNewLoanModal = () => {
        this.openConfirmationDialog(
          "Add a Loan",
          this.closeModal,
          () => {
            this.addNewLoan();
            this.closeModal();
          },
          (<><p>Do you want to create a new loan?</p></>)
        );
      }

    openConfirmationDialog = (title,onClose,onAccept,content) =>{
        this.setState({confirmationModal:{title,onClose,onAccept,content}});
        this.openModal(SIMPLE_INFO_MODAL);
    }

    closeModal = () => this.setState({ openModal: { name: null } });

    openModal = (name) => this.setState({ openModal: { name } });

    isModalOpen = (modalName) => {
        const { openModal } = this.state;
        return openModal.name === modalName;
    }

    toLoanDetails = (dealId, loanId) => {
        const {
            history,
            authentication,
            flags: {
                us1304BrokerFrontendUrlEnvironmentVariable: brokerFrontendURL,
                bar2208RedirectToNewLoanPage: newLoanPageTenants = []
            }
        } = this.props;

        const userCompanyId =
            authentication?.user?.contact?.company?.id;
        const shouldRedirectToNewPage =
            newLoanPageTenants.includes(userCompanyId);

        if (shouldRedirectToNewPage) {
            window.location.assign(`${brokerFrontendURL}/loans/${loanId}`);
        } else {
            history.push(`/loans/${loanId}`);
        }
    }

    getButtonHeaderTitle = () => {
        const { isSummaryView } = this.state;
        const {
            loans,
            guestPermission,
            flags: {
                red169ShowMultiLoanSummary: showMultiLoanSummary = false
            }
        } = this.props;

        if (!loans.length &&
            guestPermission &&
            guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT) {
            return "Add a loan";
        }

        if (loans && loans.length === 1) {
            return "Show Details";
        }

        if (!isSummaryView) {
            return "Show Summary";
        }

        return showMultiLoanSummary ? "Show Loans" : null;
    }

    handleHeaderClick = () => {
        const { isSummaryView } = this.state;
        this.setState({ isSummaryView: !isSummaryView });
    }

    renderBodyList = () => {
        const { sortedLoans, isSummaryView } = this.state;
        const {
            deal,
            flags: {
                red169ShowMultiLoanSummary: showMultiLoanSummary = false
            }
        } = this.props;
        const shouldCollapseList = showMultiLoanSummary ? !isSummaryView : true;
        return (
            <Collapse in={shouldCollapseList}>
                <div>
                    <ActiveLoanBodyList loans={sortedLoans} dealId={deal.id} toLoanDetails={this.toLoanDetails} />
                </div>
            </Collapse>
        )
    }

    renderBodySummary = () => {
        const { deal } = this.props;
        const { isSummaryView } = this.state;
        if (!deal) return null;
        return (
            <Collapse in={isSummaryView}>
                <StyledBody>
                    <ActiveLoanBodySummary dealMetrics={this.state.bodySummaryDealMetric} deal={this.props.deal} />
                </StyledBody>
            </Collapse>
        )
    }

    renderFooter = () => {
        const { deal, history, authentication, guestPermission } = this.props;
        if (!deal) return (null);
        return (
            <div style={{ borderTop: "#DADCE0 solid 1px" }}>
                <ActiveLoanHedge dealId={deal.id} history={history} authentication={authentication} guestPermission={guestPermission} />
            </div>
        )
    }

    renderHeaderAndBody = () => {
        const { authentication } = this.props;
        const { sortedLoans, distinctLenders } = this.state;

        // if they are a guest and there are no loans then return nothing
        if (authentication.isGuest && (!sortedLoans || !sortedLoans.length)) return null;

        // if they are not a guest and there are no loans then return empty loan module
        if (!sortedLoans || !sortedLoans.length) return (
            <ModuleEmptyButton
                style={{ marginTop: '2em' }}
                label={this.getButtonHeaderTitle()}
                iconName='account_balance'
                onClick={this.addNewLoanModal}
            />
        );

        if (sortedLoans && sortedLoans.length === 1) {
            const dealId = sortedLoans[0].deal.id;
            const loanId = sortedLoans[0].id;
            return (
                <ModuleBase elevation={0}>
                    <ActiveLoanHeader
                        loans={sortedLoans}
                        distinctLenders={distinctLenders}
                        buttonTitle={this.getButtonHeaderTitle()}
                        buttonOnClick={() => { this.toLoanDetails(dealId, loanId) }}
                        addLoan={this.addNewLoanModal}
                        authentication={authentication}
                    />
                    {this.renderBodySummary()}
                    {this.renderFooter()}
                </ModuleBase>
            )
        }

        return (
            <ModuleBase elevation={0}>
                <ActiveLoanHeader
                    loans={sortedLoans}
                    distinctLenders={distinctLenders}
                    buttonTitle={this.getButtonHeaderTitle()}
                    buttonOnClick={this.handleHeaderClick}
                    addLoan={this.addNewLoanModal}
                    authentication={authentication}
                />
                {this.renderBodyList()}
                {this.renderFooter()}
            </ModuleBase>
        )
    }

    render() {
        const { activeLoanModuleDealLoading } = this.props;

        if (activeLoanModuleDealLoading) return null;
        return (
            <>
                {this.renderHeaderAndBody()}
                <SimpleInfoModal
                    title={this.state.confirmationModal.title}
                    isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
                    onClose={() => this.state.confirmationModal.onClose()}
                    onAccept={() => this.state.confirmationModal.onAccept()}
                    content={this.state.confirmationModal.content}
                />
            </>
        )
    }
}

const mapStateToProps = ({ authentication, activeLoanModule }) => ({
    authentication
    , ...activeLoanModule
    , ...activeLoanModule.activeLoanModuleReducer
});

export default compose(
    withLDConsumer(),
    withRouter
    , connect(mapStateToProps, {
        activeLoanAdd
        , activeLoansGetByDealAndStatus
    })
)(ActiveLoan);
